import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const ErrorBullet = styled.div`
  width: 7px;
  height: 7px;
  background-color: ${colors.red};
  border-radius: 50%;
`;

export default ErrorBullet;
